// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { TagSourceType } from "../schema";

export function serialize_TagSourceType_internal(value: TagSourceType): unknown {
  return ((value: "USER" | "AI" | "VECTOR"): unknown => {
    return value;
  })(value);
}
export function serialize_TagSourceType(obj: TagSourceType): string {
  return renderJsonWithNumbersAsBigint(serialize_TagSourceType_internal(obj));
}
export function deserialize_TagSourceType_internal(value: unknown): ParserResult<TagSourceType> {
  return ((value: unknown): ParserResult<"USER" | "AI" | "VECTOR"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "USER":
        return { success: true, value: "USER" };
      case "AI":
        return { success: true, value: "AI" };
      case "VECTOR":
        return { success: true, value: "VECTOR" };
      default:
        return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI, VECTOR'.` };
    }
  })(value);
}
export function deserialize_TagSourceType(str: string): ParserResult<TagSourceType> {
  return deserialize_TagSourceType_internal(parseJsonWithNumbersAsBigint(str));
}
